
  <template>
  <div class="session_details_popup">
    <div class="modal-content">
      <div class="modal-body">
        <div v-if="sn" class="session-details p-4">
          <div class="sponsors-box-hld">
            <div class="media align-items-center">
              <span class="logo-hld"></span>
              <div class="media-body">
                <div class="row my-0">
                  <div class="col-lg-6 pb-0">
                    <div class="pt-1 pl-1">
                      <h3 class="mt-0">{{ sn.Name }}</h3>
                      <p class="time mb-0">
                        {{ sn.StartTimeLabel }} -
                        {{
                          sn.StartTimeLabel.substr(0, 7) ==
                          sn.EndTimeLabel.substr(0, 7)
                            ? sn.EndTimeLabel.substr(7, sn.EndTimeLabel.length)
                            : sn.EndTimeLabel
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div
                      v-if="!hideJoinButton"
                      class="
                        d-flex
                        calender-icon-hld
                        align-items-center
                        mt-2
                        session-live-des
                      "
                    >
                      <ul
                        class="d-flex align-items-center justify-content-end"
                        id="dvBroadcast"
                      >
                        <li
                          v-show="AllowAddRemoveMyAgenda && IsMyAgenda"
                          :id="'liRemoveFromMyAgenda_' + sn.SessionId"
                        >
                          <button
                            @click="removeFromMyAgenda(sn.SessionId)"
                            :id="'removeFromMyAgenda_' + sn.SessionId"
                            class="remove-agenda-button d-none1"
                          >
                            {{ $t("sessions.removeagenda") }}
                          </button>
                        </li>
                        <li
                          v-show="AllowAddRemoveMyAgenda && !IsMyAgenda"
                          :id="'liAddToMyAgenda_' + sn.SessionId"
                        >
                          <button
                            @click="addToMyAgenda(sn.SessionId)"
                            :id="'addToMyAgenda_' + sn.SessionId"
                            class="add-agenda-button d-none1"
                          >
                            {{ $t("sessions.addagenda") }}
                          </button>
                        </li>
                        <li>
                          <a
                            :class="
                              'icon-bookmark1 bmark-pupupbtn ' + sn.LinkClass
                            "
                            data-toggle="tooltip"
                            data-placement="top"
                            title=""
                            href="javascript:void(0)"
                            data-original-title="On-Demand"
                            @click="sn.IsLive ? goToSession(sn) : null"
                            :style="
                              sn.HideJoinButton ? 'visibility:hidden' : ''
                            "
                          >
                            <label>
                              <img
                                v-if="sn.SessionTypeDetails.TypeID == 1"
                                src="../assets/Images/on-demand-white.svg"
                              />
                              <img
                                v-else-if="sn.SessionTypeDetails.TypeID == 2"
                                src="../assets/Images/live-stream-white.svg"
                              />
                              <img
                                v-else-if="sn.SessionTypeDetails.TypeID == 3"
                                src="../assets/Images/live-panel-white.svg"
                              />
                              <img
                                v-else-if="sn.SessionTypeDetails.TypeID == 4"
                                src="../assets/Images/round-table-white.svg"
                              />
                              <img
                                v-else-if="sn.SessionTypeDetails.TypeID == 5"
                                :src="sn.InPersonIcon"
                              />
                            </label>
                            <span v-if="sn.SessionTypeDetails.TypeID == 1"
                              >WATCH NOW</span
                            >
                            <span v-else-if="sn.SessionTypeDetails.TypeID == 2"
                              >{{sn.SessionTypeDetails.TypeName}}</span
                            >
                            <span
                              v-else-if="sn.SessionTypeDetails.TypeID == 3"
                              >{{
                                sn.HasBackStageAccess
                                  ? "ENTER BACKSTAGE"
                                  : "JOIN NOW"
                              }}</span
                            >
                            <span v-else-if="sn.SessionTypeDetails.TypeID == 4"
                              >JOIN NOW</span
                            >
                            <span
                              v-else-if="sn.SessionTypeDetails.TypeID == 5"
                              >{{ sn.InPersonLabel }}</span
                            >
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-if="!hideAddToCalendarButton" class="col-md-12 pt-0">
                    <div
                      v-if="!hideAddToCalendarButton"
                      :class="
                        sn.EndTime >
                        parseInt(new Date().getTime() / 1000)
                          ? 'd-flex calender-icon-hld align-items-center my-2 pb-3'
                          : 'd-flex calender-icon-hld align-items-center my-2 pb-3 disabled'
                      "
                    >
                      <ul
                        v-if="
                          sn.EndTime >
                          parseInt(new Date().getTime() / 1000)
                        "
                        class="d-flex align-items-center px-0"
                      >
                        <li class="pl-0">
                          <a
                            v-bind:href="AddToCalendar(sn, 'google')"
                            target="_blank"
                          >
                            <span>
                              <img
                                src="../assets/Images/icons/google-icon.svg"
                                alt="google-icon"
                              />
                            </span>
                          </a>
                        </li>
                        <li>
                          <a
                            v-bind:href="AddToCalendar(sn, 'outlook')"
                            target="_blank"
                          >
                            <span>
                              <img
                                src="../assets/Images/icons/outlook.svg"
                                alt="outlook-icon"
                              />
                            </span>
                          </a>
                        </li>
                        <li>Add to Calendar</li>
                      </ul>
                      <ul v-else class="d-flex align-items-center px-0">
                        <li class="pl-0">
                          <a href="javascript:void(0)">
                            <span>
                              <img
                                src="../assets/Images/icons/google-icon.svg"
                                alt="google-icon"
                              />
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)">
                            <span>
                              <img
                                src="../assets/Images/icons/outlook.svg"
                                alt="outlook-icon"
                              />
                            </span>
                          </a>
                        </li>
                        <li>Add to Calendar</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <p v-html="sn.DescriptionShort"></p>
                <p v-html="sn.Description" class="mt-4"></p>
              </div>
            </div>
          </div>
          <div class="speakers-box-hld" v-show="MappedSpeakersCount > 0">
            <h2 class="sessions-hdr-next">
              {{ MappedSpeakersCount }} Speaker {{MappedSpeakersCount > 1?' (s)':''}}
            </h2>
            <div class="row mt-4">
              <div
                v-for="host in sn.MappedHosts"
                :key="host.AttendeeId"
                v-show="
                  hide_speaker_enabled == 0 ||
                  (hide_speaker_enabled == 1 && !host.HideInList)
                "
                class="col-lg-3 col-md-6 mob-pt-0"
              >
                <div
                  class="media align-items-center clsclick"
                  @click="openSpeakerDetails(host.AttendeeId)"
                >
                  <span class="logo-hld">
                    <img
                      v-if="host.ProfilePictureURL != ''"
                      :src="host.ProfilePictureURL"
                      @error="host.ProfilePictureURL = ''"
                    />
                    <span
                      v-else-if="host.NameInitial != ''"
                      class="speaker-name-initial"
                      >{{ host.NameInitial }}</span
                    >
                    <img v-else v-bind:src="avatarImageUrl" />
                  </span>
                  <div class="media-body ml-3">
                    <h4>
                      {{ host.Name }}
                      <span>[HOST]</span>
                    </h4>
                    <h5>{{ host.Company }}</h5>
                  </div>
                </div>
              </div>
              <div
                v-for="(speaker, index) in sn.MappedSpeakers"
                :key="index"
                v-show="
                  !IsHost(speaker.AttendeeId) &&
                  (hide_speaker_enabled == 0 ||
                    (hide_speaker_enabled == 1 && !speaker.HideInList))
                "
                class="col-lg-3 col-md-6"
              >
                <div
                  class="media align-items-center clsclick"
                  @click="openSpeakerDetails(speaker.AttendeeId)"
                >
                  <div class="logo-hld">
                    <img
                      v-if="speaker.ProfilePictureURL != ''"
                      :src="speaker.ProfilePictureURL"
                      @error="speaker.ProfilePictureURL = ''"
                    />
                    <span
                      v-else-if="speaker.NameInitial != ''"
                      class="speaker-name-initial"
                      >{{ speaker.NameInitial }}</span
                    >
                    <img v-else v-bind:src="avatarImageUrl" />
                  </div>
                  <div class="media-body ml-3">
                    <h4>
                      {{ speaker.Name }}
                    </h4>
                    <h5>{{ speaker.Company }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="rosource-listing-wrapper mt-1"
            v-show="sn.Resources && sn.Resources.length > 0"
          >
            <h3>Resources</h3>
            <div class="row">
              <div
                v-for="resource in sn.Resources"
                v-bind:key="resource"
                class="col-md-4"
              >
                <div class="rosource-listing">
                  <div class="d-flex justify-content-between">
                    <div class="media align-items-center">
                      <span class="logo-hld">
                        <svg
                          version="1.1"
                          id="Layer_1"
                          width="45"
                          fill="#242432"
                          height="45"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          style="enable-background: new 0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M444.875,109.792L338.208,3.125c-2-2-4.708-3.125-7.542-3.125h-224C83.135,0,64,19.135,64,42.667v426.667	C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333v-352	C448,114.5,446.875,111.792,444.875,109.792z M341.333,36.417l70.25,70.25h-48.917c-11.76,0-21.333-9.573-21.333-21.333V36.417z M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333V42.667	c0-11.76,9.573-21.333,21.333-21.333H320v64C320,108.865,339.135,128,362.667,128h64V469.333z"
                                />
                                <path
                                  d="M310.385,313.135c-9.875-7.771-19.26-15.76-25.51-22.01c-8.125-8.125-15.365-16-21.656-23.5	c9.813-30.323,14.115-45.958,14.115-54.292c0-35.406-12.792-42.667-32-42.667c-14.594,0-32,7.583-32,43.688	c0,15.917,8.719,35.24,26,57.698c-4.229,12.906-9.198,27.792-14.781,44.573c-2.688,8.052-5.604,15.51-8.688,22.406	c-2.51,1.115-4.948,2.25-7.302,3.427c-8.479,4.24-16.531,8.052-24,11.594C150.5,370.177,128,380.844,128,401.906	c0,15.292,16.615,24.76,32,24.76c19.833,0,49.781-26.49,71.656-71.115c22.708-8.958,50.938-15.594,73.219-19.75	c17.854,13.729,37.573,26.865,47.125,26.865c26.448,0,32-15.292,32-28.115c0-25.219-28.813-25.219-42.667-25.219	C337.031,309.333,325.49,310.604,310.385,313.135z M160,405.333c-6.094,0-10.219-2.875-10.667-3.427	c0-7.563,22.552-18.25,44.365-28.583c1.385-0.656,2.792-1.313,4.219-1.99C181.896,394.563,166.052,405.333,160,405.333z M234.667,214.354c0-22.354,6.938-22.354,10.667-22.354c7.542,0,10.667,0,10.667,21.333c0,4.5-3,15.75-8.49,33.313	C239.135,233.75,234.667,222.698,234.667,214.354z M242.844,329c0.667-1.854,1.313-3.729,1.938-5.625	c3.958-11.875,7.521-22.542,10.698-32.146c4.427,4.875,9.198,9.865,14.313,14.979c2,2,6.958,6.5,13.563,12.135	C270.208,321.208,256.219,324.76,242.844,329z M362.667,334.552c0,4.792,0,6.781-9.896,6.844	c-2.906-0.625-9.625-4.583-17.917-10.229c3.01-0.333,5.229-0.5,6.479-0.5C357.094,330.667,361.563,332.208,362.667,334.552z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <div class="media-body ml-3">
                        <a v-bind:href="resource" target="_blank">
                          <h4 style="word-break: break-all">
                            {{ getFileName(resource) }}
                          </h4>
                        </a>
                      </div>
                    </div>
                    <a
                      style="display: none"
                      class="no-bookmark themeiconbg"
                      title
                      data-placement="left"
                      data-toggle="tooltip"
                      href="javascript:void(0);"
                      data-original-title="Bookmark"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="42px"
                        height="42px"
                      >
                        <path
                          fill-rule="evenodd"
                          stroke-width="2px"
                          stroke="rgb(102, 102, 112)"
                          fill-opacity="0"
                          fill="rgb(3, 97, 159)"
                          d="M21.000,5.000 C29.837,5.000 37.000,12.163 37.000,21.000 C37.000,29.837 29.837,37.000 21.000,37.000 C12.163,37.000 5.000,29.837 5.000,21.000 C5.000,12.163 12.163,5.000 21.000,5.000 Z"
                        />
                        <path
                          fill-rule="evenodd"
                          fill="rgb(102, 102, 112)"
                          d="M20.989,12.000 L23.866,17.144 L29.717,18.252 L25.644,22.538 L26.383,28.366 L20.989,25.872 L15.595,28.366 L16.334,22.538 L12.261,18.252 L18.112,17.144 L20.989,12.000 "
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import jQuery from "jquery";
// let $ = jQuery;

var self;
export default {
  name: "session-details",
  props: [
    "sn",
    "hide_speaker_enabled",
    "IsMyAgenda",
    "AllowAddRemoveMyAgenda",
    "hideJoinButton",
    "hideAddToCalendarButton",
    ],
  data() {
    return {
      SessionTypeID: 1,
      Title: "",
      StartTimeLabel: "",
      EndTimeLabel: "",
      Description: "",
      DescriptionShort: "",
      StartTime: 1,
      EndTime: 1,
      LinkClass: "",
      SpeakerLength: 1,
      MappedHosts: [],
      MappedSpeakers: [],
      Resources: [],
      avatarImageUrl:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Favatar.jpg?alt=media",
    };
  },
  created() {
    self = this;
  },
  mounted() {
    //alert("mounted: " + this.sn);
  },
  watch: {
    // sn(val) {
    //   alert(val);
    // },
  },
  computed: {
    MappedSpeakersCount() {
      var result = self.sn.MappedSpeakers.length;
      if (self.hide_speaker_enabled == 1) {
        var filterResult = self.sn.MappedSpeakers.filter(function (item) {
          return !item.HideInList;
        });
        result = filterResult.length;
      }
      return result;
    },
  },
  methods: {
    IsHost(attendeeId) {
      let flag = false;
      let hosts = self.sn.MappedHosts.filter(function (item) {
        return item.AttendeeId == attendeeId;
      });
      if (hosts.length > 0) {
        flag = true;
      }
      return flag;
    },
    goToSession(session) {
      if (self.isPublicPage) {
        self.$emit("goToSession", {
          SessionId: session.SessionId,
          Name: session.Name,
          SessionTypeDetails: session.SessionTypeDetails,
        });
      } else {
        self.$emit("onStartSession", session.SessionId);
      }
    },
    addToMyAgenda(sessionId) {
      if (!self.isPublicPage) {
        self.$emit("addToMyAgenda", sessionId);
      }
    },
    removeFromMyAgenda(sessionId) {
      if (!self.isPublicPage) {
        self.$emit("removeFromMyAgenda", sessionId);
      }
    },
    openSpeakerDetails(attendeeId){
      if (!self.isPublicPage) {
        self.$emit("openSpeakerDetails", attendeeId);
      }
    },
    AddToCalendar(session, service) {
      return self.AddToEventCalendar(
        service,
        session.Name,
        session.StartTime,
        session.EndTime,
        true
      );
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
  },
};
</script>